/* eslint-disable */
import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Switch,
  FormHelperText,
  ListItemIcon,
  ListItemText,
  IconButton,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import ClearIcon from '@mui/icons-material/Clear';
import { getStorage } from '../../utils/functions/localstorage';
import api from '../../utils/functions/api';
import BankAccountPopup from '../../views/BankAccountPopup';
import AddIcon from '@mui/icons-material/Add'; // Import ไอคอน Add
import Swal from 'sweetalert2';

import kbankLogo from '../../assets/images/kbanklogo.png';
import ktbLogo from '../../assets/images/ktblogo.png';
import gsbLogo from '../../assets/images/gsblogo.png';
import ttbLogo from '../../assets/images/ttblogo.png';
import bayLogo from '../../assets/images/baylogo.png';
import bblLogo from '../../assets/images/bbllogo.png';
import scbLogo from '../../assets/images/scblogo.png';
import cimbtLogo from '../../assets/images/cimbtlogo.png';
import uobtLogo from '../../assets/images/uobtlogo.png';
import baacLogo from '../../assets/images/baaclogo.png';

const paymentOptions = [
  { label: '-', value: '-' },
  { label: 'QR Code ( OPS )', value: 'QR Code' },
  { label: 'QR Code ( New OPS )', value: 'QR Code - SCB' },
  // { label: 'QR CIMB', value: 'QR Code - CIMB' },
  { label: 'QR Credit', value: 'QR Code Credit Card' },
  { label: 'QR All In One', value: 'QR Code PromptPay Credit Card' },
  { label: 'Credit Card', value: 'Credit Card' },
  { label: 'Credit Card Foreign', value: 'Credit Card Foreign' },
  { label: 'Installment - SCB', value: 'Installment - SCB' },
  { label: 'Installment - KTC', value: 'Installment - KTC' },
  { label: 'Upload', value: 'Upload' },
  { label: 'Mobile Banking', value: 'Mobile Banking' },
  { label: 'Wallet', value: 'Wallet' },
  { label: 'Recurring', value: 'Recurring' },
  { label: 'Visual Account', value: 'Visual Account' },
];

const feeType = [
  { label: 'None', value: 'none' },
  { label: 'Fix Rate', value: 'fixed' },
  { label: 'Percentage', value: 'percentage' },
];

const revenueType = [
  { label: 'None', value: 'inactive' },
  { label: 'Active', value: 'active' },
];

const FinalConfirmationPopup = ({ open, onClose }) => (
  <Dialog
    open={open}
    onClose={onClose}
    PaperProps={{
      sx: {
        borderRadius: '15px',
        width: '400px',
      },
    }}
  >
    <DialogContent>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 'bold',
          fontSize: '24px',
          marginTop: '20px',
        }}
      >
        <CheckCircleOutlineIcon
          sx={{ fontSize: 90, color: 'green', marginBottom: '10px' }}
        />
        บันทึกสำเร็จ !
      </Box>
    </DialogContent>
    <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box
        sx={{
          width: '25%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: '1px solid',
          borderRadius: '9px',
          color: '#45A6F5',
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: '#E3F3FF',
          },
          margin: 'auto',
        }}
      >
        <Button onClick={onClose}>Close</Button>
      </Box>
    </DialogActions>
  </Dialog>
);

const EditStoreManagement = ({ open, onClose, data, username }) => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isTableLoading, setIsTableLoading] = useState(false);

  const [store, setStore] = useState({
    name: '',
    apiKey: '',
    pay_type: ['', '', ''],
    pay_type_key: ['', '', ''],
    fee_type: ['', '', ''],
    fee: ['0', '0', '0'],
    eTaxEnabled: false,
    secretKey: '',
    taxId: '',
    bank: '',
    accountName: '',
    accountNumber: '',
    logoPreview: '',
    token_payment_minutes: '',
  });

  const [errors, setErrors] = useState({
    name: '',
    apiKey: '',
    secretKey: '',
    taxId: '',
    bankError: '',
    accountNameError: '',
    accountNumberError: '',
    pay_type_key: '',
    fee_type: '',
  });

  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState('');
  const [logoRemoved, setLogoRemoved] = useState(false);

  const base64ToFile = async (base64String, fileName) => {
    // ใช้ fetch เพื่อแปลง base64 เป็น Blob
    const response = await fetch(base64String);
    const blob = await response.blob();

    // สร้างไฟล์จาก Blob โดยตั้งชื่อและประเภทไฟล์
    const file = new File([blob], fileName, { type: blob.type });
    return file;
  };

  useEffect(() => {
    if (data) {
      // ล้างค่ารูปภาพเริ่มต้นเมื่อมีการเปลี่ยนข้อมูล

      console.log('data', data);
      setLogoFile(null);
      setLogoPreview('');
      setLogoRemoved(false);

      let paymentMethods = Array.isArray(data.pay_type) ? data.pay_type : [];

      setStore({
        name: data.name || '',
        apiKey: data.etax_api_key || '',
        pay_type: paymentMethods || ['', '', ''],
        pay_type_key: Array.isArray(data.pay_type_key)
          ? data.pay_type_key
          : ['', '', ''],
        fee_type: Array.isArray(data.fee_type) ? data.fee_type : ['', '', ''],
        fee: Array.isArray(data.fee) ? data.fee : ['', '', ''],
        eTaxEnabled: data.etax === 'true',
        secretKey: data.etax_secret_key || '',
        taxId: data.etax_id || '',
        accountNumber: data.account_number || '',
        bank: data.account_bank_id || '',
        accountName: data.account_name || '',
        token_payment_minutes: data.token_payment_minutes || '',
        revenue:
          Array.isArray(data.recipient_id_status) &&
          data.recipient_id_status.includes('active')
            ? 'active'
            : 'inactive',
        recipient_id: Array.isArray(data.recipient_id)
          ? data.recipient_id
          : ['', '', ''],
      });

      // เช็คว่า data.image มีค่า หรือไม่
      if (data.image) {
        // สร้าง base64String จากข้อมูลที่ได้รับ โดยอาจเป็น jpeg หรือรูปแบบอื่น
        const base64String = `data:image/jpeg;base64,${data.image}`;
        setLogoPreview(base64String); // แสดงรูป preview จาก base64

        // แปลง base64 เป็นไฟล์รูปภาพ png
        base64ToFile(base64String, 'logo.jpg').then((file) => {
          // ใช้ฟังก์ชัน convertToPNG แปลงเป็นไฟล์ PNG
          convertToPNG(file).then((pngFile) => {
            setLogoFile(pngFile); // ตั้งค่าไฟล์รูปภาพเพื่อการบันทึกเป็น PNG
          });
        });
      } else {
        // ถ้าไม่มีข้อมูลรูปภาพให้ล้างค่าทั้งหมด
        setLogoPreview('');
        setLogoFile(null);
      }
    }
  }, [data]);

  const convertToPNG = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = function (event) {
        const img = new Image();
        img.src = event.target.result;
        img.onload = function () {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          canvas.toBlob((blob) => {
            const pngFile = new File([blob], 'logo.png', { type: 'image/png' });
            resolve(pngFile);
          }, 'image/png');
        };
      };
      reader.onerror = reject;
      reader.readAsDataURL(file); // แปลงไฟล์ที่อัปโหลดเป็น Data URL
    });
  };

  const handleStoreChange = (e) => {
    const { name, value, checked, type } = e.target;
    if (name.startsWith('pay_type_key')) {
      const index = parseInt(name.replace('pay_type_key', ''), 10) - 1;
      setStore((prevStore) => {
        const updatedKeys = [...prevStore.pay_type_key];
        updatedKeys[index] = value;

        setErrors((prevErrors) => ({
          ...prevErrors,
          [`pay_type_key${index + 1}`]: '', // เคลียร์ error
        }));

        return { ...prevStore, pay_type_key: updatedKeys };
      });
    } else if (name.startsWith('pay_type')) {
      const index = parseInt(name.replace('pay_type', ''), 10) - 1;
      setStore((prevStore) => {
        const newPayments = [...prevStore.pay_type];
        newPayments[index] = value || ''; // กำหนดค่าเริ่มต้นเป็น '' ถ้าไม่มีค่า

        setErrors((prevErrors) => ({
          ...prevErrors,
          [`pay_type${index + 1}`]: '', // เคลียร์ error
        }));

        return {
          ...prevStore,
          pay_type: newPayments,
        };
      });
    } else if (name.startsWith('fee_type')) {
      const index = parseInt(name.replace('fee_type', ''), 10) - 1;
      console.log(`เลือก fee_type index ${index}:`, value); // ✅ log ค่าที่เลือก

      setStore((prevStore) => {
        const updatedFeeTypes = [...(prevStore.fee_type || [])];
        updatedFeeTypes[index] = value;
        console.log('updatedFeeTypes:', updatedFeeTypes); // ✅ debug ตรงนี้ด้วย

        return {
          ...prevStore,
          fee_type: updatedFeeTypes,
        };
      });

      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        newErrors.fee_type = [...(newErrors.fee_type || [])];
        if (!value.trim()) {
          newErrors.fee_type[index] = `กรุณาเลือกประเภทค่าธรรมเนียม ${
            index + 1
          }`;
        } else {
          newErrors.fee_type[index] = '';
        }
        return newErrors;
      });
    } else if (name.startsWith('fee')) {
      const index = parseInt(name.replace('fee', ''), 10) - 1;
      setStore((prevStore) => {
        const updatedFees = [...prevStore.fee];
        updatedFees[index] = value;
        return { ...prevStore, fee: updatedFees };
      });
    } else if (name.startsWith('recipient_id')) {
      const index = parseInt(name.replace('recipient_id', ''), 10) - 1;
      const newValue = value;

      setStore((prevStore) => {
        const newRecipientIds = [...(prevStore.recipient_id || [])];
        newRecipientIds[index] = newValue;

        return {
          ...prevStore,
          recipient_id: newRecipientIds,
        };
      });

      // setErrors((prevErrors) => {
      //   const newErrors = { ...prevErrors };
      //   if (newValue.trim() || store.pay_type[index]) {
      //     newErrors.pay_type_key = [...(newErrors.pay_type_key || [])];
      //     newErrors.pay_type_key[index] = '';
      //   }
      //   return newErrors;
      // });
    } else {
      setStore((prevStore) => ({
        ...prevStore,
        [name]: type === 'checkbox' ? checked : value,
      }));

      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: '', // เคลียร์ error สำหรับฟิลด์ที่มีการกรอกข้อมูล
      }));
    }

    if (name === 'bank') {
      setStore((prevStore) => ({
        ...prevStore,
        accountNumber: '', // Clear account number when bank changes
        [name]: value,
      }));

      setErrors((prevErrors) => ({
        ...prevErrors,
        bankError: '', // เคลียร์ error ของธนาคารเมื่อเลือกธนาคารใหม่
      }));
    }

    if (name === 'accountNumber') {
      let maxLength = 10;

      if (store.bank === 'GSB') {
        maxLength = 12;
      } else if (store.bank === 'BAAC') {
        maxLength = 13;
      }

      if (/^\d*$/.test(value)) {
        setStore((prevStore) => ({
          ...prevStore,
          accountNumber: value.slice(0, maxLength),
        }));
      }
    }

    if (value === 'Upload') {
      setOpenBankAccountPopup(true);
    } else {
      setOpenBankAccountPopup(false);
    }
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      // แปลงไฟล์ที่อัปโหลดเป็น PNG
      convertToPNG(file).then((pngFile) => {
        setLogoFile(pngFile); // ตั้งค่าไฟล์ PNG เพื่อส่งไปบันทึก
        setLogoPreview(URL.createObjectURL(pngFile)); // แสดง preview
        setLogoRemoved(false); // เมื่ออัปโหลดรูปใหม่ จะไม่ลบโลโก้
      });
    }
  };

  const handleRemoveLogo = () => {
    setLogoPreview(''); // ลบรูป preview
    setLogoFile(null); // ลบไฟล์รูป
    setLogoRemoved(true); // ตั้งค่าลบโลโก้
  };

  const handleEdit = async () => {
    setIsTableLoading(true);
    setErrors({
      name: '',
      apiKey: '',
      secretKey: '',
      taxId: '',
      bankError: '',
      accountNameError: '',
      accountNumberError: '',
      pay_type_key: '',
    }); // Reset errors

    let hasError = false;

    if (!store.name) {
      setErrors((prev) => ({ ...prev, name: 'กรุณากรอกชื่อร้านค้า' }));
      hasError = true;
    }
    // Validate E-Tax fields
    if (store.eTaxEnabled) {
      if (!store.apiKey) {
        setErrors((prev) => ({ ...prev, apiKey: 'กรุณากรอก API KEY' }));
        hasError = true;
      }
      if (!store.secretKey) {
        setErrors((prev) => ({
          ...prev,
          secretKey: 'กรุณากรอก SECRET KEY',
        }));
        hasError = true;
      }
      if (!store.taxId) {
        setErrors((prev) => ({ ...prev, taxId: 'กรุณากรอก TAX ID' }));
        hasError = true;
      }
    }

    // Validate bank account fields if payment is "Upload"
    if (store.pay_type.includes('Upload')) {
      if (!store.bank) {
        setErrors((prev) => ({ ...prev, bankError: 'กรุณาเลือกธนาคาร' }));
        hasError = true;
      }
      if (!store.accountName) {
        setErrors((prev) => ({
          ...prev,
          accountNameError: 'กรุณากรอกชื่อบัญชี',
        }));
        hasError = true;
      }
      if (!store.accountNumber) {
        setErrors((prev) => ({
          ...prev,
          accountNumberError: 'กรุณากรอกเลขที่บัญชี',
        }));
        hasError = true;
      }
    }

    store.pay_type.forEach((payType, index) => {
      if (payType && !store.pay_type_key[index]) {
        setErrors((prev) => ({
          ...prev,
          [`pay_type_key${index + 1}`]: 'กรุณากรอกคีย์ช่องทางการชำระ',
        }));
        hasError = true;
      }
    });

    if (hasError) {
      setIsTableLoading(false);
      return;
    }

    try {
      const recipientCount = store.recipient_id.length;

      // สร้าง array ใหม่ที่แต่ละค่าเท่ากับ store.revenue
      const recipientStatusArray = Array(recipientCount).fill(store.revenue);

      const formData = new FormData();
      formData.append('id', data.id);
      formData.append('name', store.name);
      formData.append('token_payment_minutes', store.token_payment_minutes);
      formData.append('pay_type', JSON.stringify(store.pay_type)); // ส่ง payment เป็น JSON string
      formData.append('fee', JSON.stringify(store.fee)); // ตรวจสอบการส่งค่า fee
      formData.append('fee_type', JSON.stringify(store.fee_type)); // ตรวจสอบการส่งค่า fee_type
      formData.append('etax', store.eTaxEnabled);
      formData.append('etax_api_key', store.apiKey);
      formData.append('etax_secret_key', store.secretKey);
      formData.append('etax_id', store.taxId);
      formData.append('account_name', store.accountName);
      formData.append('account_number', store.accountNumber);
      formData.append('account_bank_id', store.bank);
      formData.append('recipient_id', JSON.stringify(store.recipient_id));
      formData.append(
        'recipient_id_status',
        JSON.stringify(recipientStatusArray),
      );
      formData.append('createBy', getStorage('username'));

      if (store.pay_type_key) {
        formData.append('pay_type_key', JSON.stringify(store.pay_type_key));
      }

      if (logoFile) {
        formData.append('img_logo', logoFile); // ส่งไฟล์รูปภาพ (เป็น PNG เสมอ)
      } else if (logoRemoved) {
        formData.append('img_logo', ''); // ส่งค่าว่างหากลบโลโก้
      } else {
        formData.append('img_logo', data.image || ''); // ส่งรูปจากฐานข้อมูลหากยังมีอยู่
      }

      let { data: responseData } = await api.post(
        `${process.env.REACT_APP_APIHOST}/edit_customer`,
        formData,
        {
          headers: {
            Authorization: getStorage('token'),
            'Content-Type': 'multipart/form-data', // Important for file upload
          },
        },
      );

      if (responseData === 'edit success') {
        setShowConfirmation(true);
      }
    } catch (error) {
      console.log(error); // เอาไว้ดู log เผื่อมี error อื่นๆ

      // 1. ตั้งค่าข้อความแจ้งเตือนเริ่มต้น (Fallback)
      let errorTitle = 'เกิดข้อผิดพลาด';
      let errorText = 'เกิดข้อผิดพลาดในการบันทึกข้อมูล';

      // 2. ดึงข้อความจาก API (ใช้ Optional Chaining ?. เพื่อป้องกันโค้ดพัง)
      const apiMessage = error?.response?.data?.message || '';

      // 3. ตรวจสอบเงื่อนไขข้อความจาก API
      if (apiMessage.includes('Duplicate MKEY')) {
        // ถ้า API บ่นเรื่องคีย์ซ้ำ ให้แสดงข้อความภาษาไทยที่เข้าใจง่ายๆ
        errorText =
          'MKEY หรือคีย์ช่องทางการชำระนี้ถูกใช้งานแล้ว กรุณาตรวจสอบอีกครั้ง';
      } else if (apiMessage) {
        // ถ้าเป็น Error อื่นๆ ที่มี message ค่อยเอามาแสดง
        errorText = apiMessage;
      }

      // 4. เรียกใช้ Swal แค่ครั้งเดียวพอ
      Swal.fire({
        icon: 'error',
        title: errorTitle,
        text: errorText,
        confirmButtonText: 'ตกลง',
        willOpen: () => {
          // บังคับให้อยู่บนสุด (เผื่อโดน Dialog หรือ Modal ของ MUI ทับ)
          const swalContainer = document.querySelector('.swal2-container');
          if (swalContainer) {
            swalContainer.style.zIndex = 9999;
          }
        },
      });
    } finally {
      setIsTableLoading(false);
    }
  };

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
    window.location.reload();
  };

  const handleAddPayment = () => {
    setStore((prevStore) => ({
      ...prevStore,
      pay_type: [...prevStore.pay_type, ''], // Add an empty payment method
      pay_type_key: [...prevStore.pay_type_key, ''], // Add an empty key for the new payment method
      fee: [...prevStore.fee, ''], // Add an empty fee for the new payment method
      fee_type: [...prevStore.fee_type, 'none'], // เพิ่มประเภทค่าธรรมเนียมใหม่ที่มีค่าเริ่มต้นเป็น 'none'
      recipient_id: [...prevStore.recipient_id, ''], // เพิ่ม recipient_id ใหม่
    }));
  };

  const handleCloseEditDialog = () => {
    setLogoPreview(''); // รีเซ็ต preview ของโลโก้
    setLogoFile(null); // รีเซ็ตไฟล์โลโก้
    setLogoRemoved(false);
    onClose(); // เรียกใช้งานฟังก์ชัน onClose ดั้งเดิมที่ส่งมา
  };

  const [openBankAccountPopup, setOpenBankAccountPopup] = useState(false);

  const bankOptions = [
    { label: 'ธนาคารกสิกรไทย', value: 'KBANK', icon: kbankLogo },
    { label: 'ธนาคารกรุงไทย', value: 'KTB', icon: ktbLogo },
    { label: 'ธนาคารออมสิน', value: 'GSB', icon: gsbLogo },
    { label: 'ธนาคารทหารไทยธนชาต', value: 'TTB', icon: ttbLogo },
    { label: 'ธนาคารกรุงศรีอยุธยา', value: 'BAY', icon: bayLogo },
    { label: 'ธนาคารกรุงเทพ', value: 'BBL', icon: bblLogo },
    { label: 'ธนาคารไทยพาณิชย์', value: 'SCB', icon: scbLogo },
    { label: 'ธนาคารซีไอเอ็มบีไทย', value: 'CIMB', icon: cimbtLogo },
    { label: 'ธนาคารยูโอบี', value: 'UOB', icon: uobtLogo },
    {
      label: 'ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร',
      value: 'BAAC',
      icon: baacLogo,
    },
  ];

  const handleDeletePayment = (index) => {
    // เช็คว่ามีช่องทางการชำระมากกว่า 1 ช่องทางก่อนถึงจะลบได้
    if (store.pay_type.length > 1) {
      // ลบช่องทางการชำระ
      const updatedPayment = store.pay_type.filter((_, i) => i !== index);
      // ลบคีย์ที่เกี่ยวข้อง
      const updatedPaymentKeys = store.pay_type_key.filter(
        (_, i) => i !== index,
      );
      const updatedFees = store.fee.filter((_, i) => i !== index);
      const updatedFeesType = store.fee_type.filter((_, i) => i !== index);

      setStore({
        ...store,
        pay_type: updatedPayment,
        pay_type_key: updatedPaymentKeys, // อัปเดตคีย์ไปพร้อมกัน
        fee: updatedFees, // Ensure fee is updated as well
        fee_type: updatedFeesType,
      });
    } else {
      alert('ต้องมีอย่างน้อย 1 ช่องทางการชำระ'); // แสดงข้อความแจ้งเตือน
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleCloseEditDialog}
        PaperProps={{
          sx: {
            borderRadius: '15px',
            width: '100%',
            maxWidth: '1400px',
          },
        }}
      >
        <DialogTitle>
          <Grid
            container
            alignItems="center"
            spacing={2}
            style={{ marginTop: '10px' }}
            justifyContent="space-between"
          >
            <Grid item xs={4} sm={8}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  fontWeight: 'bold',
                  marginLeft: '10px',
                  fontSize: { xs: '16px', sm: '20px' }, // ขนาดฟอนต์ responsive
                  width: '100%',
                }}
              >
                แก้ไขร้านค้า
              </Box>
            </Grid>
            <Grid item xs={8} sm={4} container justifyContent="flex-end">
              <Button
                onClick={handleAddPayment}
                variant="contained"
                color="primary"
                size="medium"
                startIcon={<AddIcon />}
                sx={{ marginRight: '4px' }}
              >
                ช่องทางการชำระ
              </Button>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              marginRight: '10px',
              marginLeft: '10px',
              marginTop: '6px',
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={8}>
                <TextField
                  label="ชื่อร้านค้า"
                  variant="outlined"
                  fullWidth
                  name="name"
                  value={store.name}
                  onChange={handleStoreChange}
                  size="small"
                  error={Boolean(errors.name)}
                  helperText={errors.name}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <TextField
                  label="เวลาหมดอายุ (นาที)"
                  variant="outlined"
                  fullWidth
                  type="number"
                  name="token_payment_minutes"
                  value={store.token_payment_minutes}
                  onChange={handleStoreChange}
                  size="small"
                  error={Boolean(errors.token_payment_minutes)}
                  helperText={errors.token_payment_minutes}
                  inputProps={{ min: 1 }} // ✅ ป้องกันค่าติดลบ
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormControl
                  variant="outlined"
                  fullWidth
                  size="small"
                  // error={errors.pay_type && !!errors.pay_type} // แสดง error สำหรับเฉพาะช่องที่ไม่ถูกต้อง
                >
                  <InputLabel>{`Revenue`}</InputLabel>
                  <Select
                    label={`Revenue`}
                    name={`revenue`}
                    value={store.revenue || 'inactive'}
                    onChange={handleStoreChange}
                  >
                    {revenueType.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>

                  {/* แสดงข้อความแจ้งเตือนเฉพาะช่องที่ไม่ถูกต้อง */}
                  {/* {errors.pay_type && errors.pay_type && (
                    <FormHelperText>{errors.pay_type}</FormHelperText>
                  )} */}
                </FormControl>
              </Grid>
              {/* {store.payment.map((paymentOption, i) => (
                <Grid item xs={12} sm={6} key={i}>
                  <FormControl variant="outlined" fullWidth size="small">
                    <InputLabel>{`ช่องทางการชำระ ${i + 1}`}</InputLabel>
                    <Select
                      label={`ช่องทางการชำระ ${i + 1}`}
                      name={`payment${i + 1}`}
                      value={store.payment[i] || ''}
                      onChange={handleStoreChange}
                    >
                      {paymentOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              ))} */}
              {store.pay_type.map((paymentOption, i) => (
                <Grid
                  container
                  spacing={2}
                  key={i}
                  sx={{
                    display: 'flex',
                    marginRight: '2px',
                    marginLeft: '2px',
                    marginTop: '3px',
                  }}
                >
                  <Grid item xs={12} sm={2}>
                    <FormControl variant="outlined" fullWidth size="small">
                      <InputLabel>{`ช่องทางการชำระ ${i + 1}`}</InputLabel>
                      <Select
                        label={`ช่องทางการชำระ ${i + 1}`}
                        name={`pay_type${i + 1}`}
                        value={store.pay_type[i] || ''}
                        onChange={handleStoreChange}
                      >
                        {paymentOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* เพิ่ม TextField ที่นี่ */}
                  <Grid item xs={12} sm={3}>
                    <TextField
                      label={`คีย์ช่องทางการชำระ ${i + 1}`}
                      variant="outlined"
                      fullWidth
                      name={`pay_type_key${i + 1}`}
                      value={store.pay_type_key[i] || ''}
                      onChange={handleStoreChange}
                      size="small"
                      error={!!errors[`pay_type_key${i + 1}`]} // แสดง error
                      helperText={errors[`pay_type_key${i + 1}`] || ''} // ข้อความแจ้งเตือน
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <FormControl
                      variant="outlined"
                      fullWidth
                      size="small"
                      error={errors.pay_type && !!errors.pay_type[i]} // แสดง error สำหรับเฉพาะช่องที่ไม่ถูกต้อง
                    >
                      <InputLabel>{`ประเภทค่าธรรมเนียม ${i + 1}`}</InputLabel>
                      <Select
                        label={`ประเภทค่าธรรมเนียม ${i + 1}`}
                        name={`fee_type${i + 1}`}
                        value={store.fee_type[i] || ''}
                        onChange={handleStoreChange}
                      >
                        {feeType.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>

                      {/* แสดงข้อความแจ้งเตือนเฉพาะช่องที่ไม่ถูกต้อง */}
                      {errors.pay_type && errors.pay_type[i] && (
                        <FormHelperText>{errors.pay_type[i]}</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={10} sm={2}>
                    <TextField
                      label={`ค่าธรรมเนียม ${i + 1}`}
                      variant="outlined"
                      fullWidth
                      name={`fee${i + 1}`}
                      value={store.fee[i] ?? ''} // ป้องกัน undefined
                      onChange={(e) => {
                        const value = e.target.value;
                        // อนุญาตให้กรอกเฉพาะตัวเลขที่มีทศนิยมไม่เกิน 2 ตำแหน่ง
                        if (/^\d*\.?\d{0,2}$/.test(value)) {
                          handleStoreChange(e);
                        }
                      }}
                      size="small"
                      type="text" // ใช้ text เพื่อควบคุม pattern ได้เต็มที่
                      disabled={
                        !store.fee_type[i] ||
                        store.fee_type[i].trim() === 'none'
                      }
                      inputProps={{
                        inputMode: 'decimal',
                        pattern: '^\\d*\\.?\\d{0,2}$',
                      }}
                    />
                  </Grid>

                  {store.revenue === 'active' && (
                    <Grid item xs={12} sm={2}>
                      <TextField
                        label={`Recipient ID`}
                        variant="outlined"
                        fullWidth
                        name={`recipient_id ${i + 1}`}
                        value={store.recipient_id?.[i] || ''}
                        onChange={handleStoreChange} // อัปเดตเฉพาะค่าของฟิลด์ ไม่ยุ่งเกี่ยวกับสถานะ Checkbox
                        size="small"
                        error={!!errors.recipient_id?.[i]} // ตรวจสอบ errors และแสดง
                        helperText={errors.recipient_id?.[i] || ''}
                      />
                    </Grid>
                  )}

                  <Grid item xs={1} sm={0.5} sx={{ textAlign: 'right' }}>
                    <IconButton
                      onClick={() => handleDeletePayment(i)} // ฟังก์ชันที่ลบช่องทางการชำระตาม index
                      color="error"
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              ))}
              <Grid item xs={12} sm={12}>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  style={{ display: 'none' }}
                  id="upload-logo"
                />
                <label htmlFor="upload-logo">
                  <Button variant="contained" color="primary" component="span">
                    Upload Logo
                  </Button>
                </label>
                {logoPreview && (
                  <Box
                    sx={{
                      position: 'relative',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginTop: '10px',
                    }}
                  >
                    <img
                      src={logoPreview}
                      alt="Logo Preview"
                      style={{
                        width: '100%',
                        height: 'auto',
                        maxWidth: '300px',
                      }}
                    />
                    <IconButton
                      aria-label="remove-logo"
                      onClick={handleRemoveLogo}
                      sx={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        color: '#fffffff',
                      }}
                    >
                      <ClearIcon />
                    </IconButton>
                  </Box>
                )}
              </Grid>
              <Grid item xs={12}>
                <Switch
                  color="primary"
                  name="eTaxEnabled"
                  inputProps={{ 'aria-label': 'e-tax switch' }}
                  checked={store.eTaxEnabled}
                  onChange={handleStoreChange}
                  size="small"
                />
                E-TAX
              </Grid>
              {store.eTaxEnabled && (
                <>
                  <Grid item xs={12}>
                    <TextField
                      label="API KEY"
                      variant="outlined"
                      fullWidth
                      name="apiKey"
                      value={store.apiKey}
                      onChange={handleStoreChange}
                      size="small"
                      error={Boolean(errors.apiKey)}
                      helperText={errors.apiKey}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="SECRET KEY"
                      variant="outlined"
                      fullWidth
                      name="secretKey"
                      value={store.secretKey}
                      onChange={handleStoreChange}
                      size="small"
                      error={Boolean(errors.secretKey)}
                      helperText={errors.secretKey}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="TAX ID"
                      variant="outlined"
                      fullWidth
                      name="taxId"
                      value={store.taxId}
                      onChange={(e) => {
                        const re = /^[0-9\b]+$/; // Regular expression to allow only numbers
                        if (e.target.value === '' || re.test(e.target.value)) {
                          handleStoreChange(e); // Call the existing change handler if input is valid
                        }
                      }}
                      size="small"
                      error={Boolean(errors.taxId)}
                      helperText={errors.taxId}
                      inputProps={{
                        pattern: '[0-9]*',
                        inputMode: 'numeric',
                      }}
                    />
                  </Grid>
                </>
              )}
              {store.pay_type.includes('Upload') && (
                <Grid
                  container
                  spacing={2}
                  sx={{
                    width: '100%',
                    maxWidth: '1000px',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginBottom: '18px',
                    marginTop: '40px',
                  }}
                >
                  <Grid item xs={12} sm={12} md={12}>
                    <Box display="flex" alignItems="center">
                      <div
                        style={{
                          wordBreak: 'break-all',
                          whiteSpace: 'normal',
                          fontWeight: 'bold',
                          fontSize: '17px',
                        }}
                      >
                        ข้อมูลรายละเอียดเลขที่บัญชี
                      </div>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      error={Boolean(errors.bankError)}
                      size="small"
                    >
                      <InputLabel>เลือกธนาคาร</InputLabel>
                      <Select
                        name="bank"
                        value={store.bank}
                        onChange={handleStoreChange}
                        label="เลือกธนาคาร"
                        size="small"
                        renderValue={(selected) => {
                          const selectedBank = bankOptions.find(
                            (option) => option.value === selected,
                          );
                          return (
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                              <img
                                src={selectedBank?.icon}
                                alt={selectedBank?.label}
                                style={{
                                  width: '24px',
                                  height: '24px',
                                  marginRight: '8px',
                                }}
                              />
                              {selectedBank?.label}
                            </Box>
                          );
                        }}
                      >
                        {bankOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            <ListItemIcon>
                              <img
                                src={option.icon}
                                alt={option.label}
                                style={{ width: '24px', height: '24px' }}
                              />
                            </ListItemIcon>
                            <ListItemText primary={option.label} />
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.bankError && (
                        <FormHelperText>{errors.bankError}</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="ชื่อบัญชี"
                      variant="outlined"
                      fullWidth
                      name="accountName"
                      value={store.accountName}
                      onChange={handleStoreChange}
                      size="small"
                      error={Boolean(errors.accountNameError)}
                      helperText={errors.accountNameError}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="เลขที่บัญชี"
                      variant="outlined"
                      fullWidth
                      name="accountNumber"
                      value={store.accountNumber}
                      onChange={handleStoreChange}
                      size="small"
                      inputProps={{
                        maxLength:
                          store.bank === 'GSB'
                            ? 12
                            : store.bank === 'BAAC'
                              ? 13
                              : 10,
                        pattern: '[0-9]*',
                        inputMode: 'numeric',
                        onInput: (e) => {
                          e.target.value = e.target.value.replace(/\D/g, '');
                        },
                      }}
                      error={Boolean(errors.accountNumberError)}
                      helperText={errors.accountNumberError}
                    />
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions sx={{ marginBottom: '20px', marginRight: '20px' }}>
          <Button
            onClick={onClose}
            sx={{
              width: '100px',
              border: '1px solid',
              color: '#FC3A3A',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(252, 58, 58, 0.1)',
              },
            }}
          >
            ยกเลิก
          </Button>
          <Button
            onClick={handleEdit}
            sx={{
              width: '100px',
              border: '1px solid ',
              color: '#51D245',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(81, 210, 69, 0.1)',
              },
            }}
          >
            บันทึก
          </Button>
        </DialogActions>
      </Dialog>
      <FinalConfirmationPopup
        open={showConfirmation}
        onClose={handleCloseConfirmation}
      />
    </>
  );
};

export default EditStoreManagement;
